import React from "react";
import {useSelector} from "react-redux";
import {useJwt} from "../helpers/common";

interface CostProps {
  project_costs?: {
    total_cost?: number;
    total_billing?: number;
  }
}

const Cost: React.FC<CostProps> = ({ project_costs }) => {
  const jwtData: any = useJwt();
  const { show_cost: showCost } = useSelector((state: any) => state.organization.orgDetails);
  const isAdmin = typeof jwtData?.org_role === 'string' && jwtData?.org_role?.toLowerCase() === 'admin';
  const totalCost = project_costs?.total_cost ?? 0

  const formatCurrency = (value: number) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(value);

  if(!isAdmin || !showCost) return null;

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold ${
        totalCost >= 0
          ? 'text-green-700 dark:text-green-300 bg-green-50 dark:bg-green-900/20'
          : 'text-red-700 dark:text-red-300 bg-red-50 dark:bg-red-900/20'
        }
      `}
      title={`Total Project Cost: ${formatCurrency(totalCost)}`}
    >
      {formatCurrency(totalCost)}
    </span>
  );
};

export default Cost;